//#region src/modules/Files/utils/generate-file-thumbnail.ts
function generateFileThumbnail(file, dimensions) {
	if (!dimensions || dimensions.length != 2) throw "You need to give the dimensions";
	const reader = new FileReader();
	const canvas = document.createElement("canvas");
	const ctx = canvas.getContext("2d");
	return new Promise((resolve, reject) => {
		reader.addEventListener("load", function() {
			const img = new Image();
			img.onload = function() {
				const scaleRatio = Math.min(...dimensions) / Math.max(img.width, img.height);
				const w = img.width * scaleRatio;
				const h = img.height * scaleRatio;
				canvas.width = w;
				canvas.height = h;
				ctx?.drawImage(img, 0, 0, w, h);
				return resolve(canvas.toDataURL(file.type));
			};
			if (typeof this.result === "string") img.src = this.result;
			else {
				console.error("generateThumbnail() reader.readAsDataURL(file) no result");
				reject("generateThumbnail() reader.readAsDataURL(file) no result");
			}
		});
		reader.readAsDataURL(file);
	});
}
//#endregion
export { generateFileThumbnail };

//# sourceMappingURL=generate-file-thumbnail.js.map